<template>
  <div class="financeChain">
    <div class="one1">
        <img class="icon" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/home_back9.jpg" alt="">
        <div class="one1_content">
            <div class="title_name title_name_one">硬木解决方案</div>
            <div class="title_name title_name_two">Solution</div>
        </div>
    </div>
    <div class="one2">
        <div class="enterprise_content">
            <div class="one1_pain_point">
                <painPoint />
            </div>
        </div>
    </div>
    <div class="one3">
        <div class="enterprise_content one3_content">
            <div class="left">
                <ul class="solutions">
                    <li>1.系统通过岗位分配对应的工作权限，各司其职协同办公，大大提高工作效率，降低人工失误率。</li>
                    <li>2.电脑端系统配合移动端小程序完全实现无纸化办公环境。</li>
                    <li>3.关键节点控制，通过销售审核、财务审核、出库审核等节点各个把控，让企业运作井然有序。</li>
                    <li class="wow animate__animated animate__bounceInLeft">
                        <img src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/hardwood/scheme_index2.png" alt="">
                    </li>
                    <li>
                        <img src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/hardwood/scheme_index1.png" alt="">
                    </li>
                    <li>
                        <div class="item_bottom">
                            <div class="ontrial"><img src="../../../../public/images/free.png" alt=""> 免费试用</div>
                            <div class="consult"><img class="be" src="../../../../public/images/consult.png" alt=""><img class="be_wh" src="../../../../public/images/consult_wh.png" alt=""> 详情咨询</div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="right">
                <div class="title">企业协同解决方案</div>
                <img class="icon wow animate__animated animate__bounceInRight" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/hardwood/scheme_index3.png" alt="">
            </div>
        </div>
    </div>
    <div class="one4">
        <div class="enterprise_content one4_content">
            <div class="title">CRM客户管理解决方案</div>
            <div class="solutions_content">
                <solutions />
            </div>
            <div class="solutions_bottom_content">
                <ul class="left content_ul">
                    <li class="wow animate__animated animate__fadeInLeftBig" v-for="(item,index) in one4List" :key="index">
                        <div class="name">{{item.name}}</div>
                        <div class="explain">{{item.explain}}</div>
                    </li>
                </ul>
                <div class="right">
                    <div class="item_bottom">
                        <div class="ontrial"><img src="../../../../public/images/free.png" alt=""> 免费试用</div>
                        <div class="consult"><img class="be" src="../../../../public/images/consult.png" alt=""><img class="be_wh" src="../../../../public/images/consult_wh.png" alt=""> 详情咨询</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="one5">
        <div class="enterprise_content one5_content">
            <div class="left">
                <div class="title">入库解决方案</div>
                <ul class="left_content content_ul">
                    <li class="wow animate__animated animate__fadeInLeftBig" v-for="(item,index) in one5List" :key="index">
                        <div class="name">{{item.name}}</div>
                        <div class="explain">{{item.explain}}</div>
                    </li>
                    <li>
                        <div class="item_bottom">
                            <div class="ontrial"><img src="../../../../public/images/free.png" alt=""> 免费试用</div>
                            <div class="consult"><img class="be" src="../../../../public/images/consult.png" alt=""><img class="be_wh" src="../../../../public/images/consult_wh.png" alt=""> 详情咨询</div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="right">
                <inWarehous />
            </div>
        </div>
    </div>
    <div class="one6">
        <div class="enterprise_content one6_content">
            <div class="left">
                <stock />
            </div>
            <div class="right">
                <div class="title">库存资源解决方案</div>
                <ul class="content_ul">
                    <li class="wow animate__animated animate__fadeInRightBig" v-for="(item,index) in one6List" :key="index">
                        <div class="name">{{item.name}}</div>
                        <div class="explain">{{item.explain}}</div>
                    </li>
                    <li>
                        <div class="item_bottom">
                            <div class="ontrial"><img src="../../../../public/images/free.png" alt=""> 免费试用</div>
                            <div class="consult"><img class="be" src="../../../../public/images/consult.png" alt=""><img class="be_wh" src="../../../../public/images/consult_wh.png" alt=""> 详情咨询</div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="one7">
        <div class="enterprise_content one7_content">
            <div class="left">
                <div class="title">销售管理解决方案</div>
                <ul class="content_ul">
                    <li class="wow animate__animated animate__fadeInLeftBig" v-for="(item,index) in one7List" :key="index">
                        <div class="name">{{item.name}}</div>
                        <div class="explain">{{item.explain}}</div>
                    </li>
                    <li>
                        <div class="item_bottom">
                            <div class="ontrial"><img src="../../../../public/images/free.png" alt=""> 免费试用</div>
                            <div class="consult"><img class="be" src="../../../../public/images/consult.png" alt=""><img class="be_wh" src="../../../../public/images/consult_wh.png" alt=""> 详情咨询</div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="right">
                <sale />
            </div>
        </div>
    </div>
    <div class="one8">
        <div class="enterprise_content one8_content">
            <div class="left">
                <finance />
            </div>
            <div class="right">
                <div class="title">财务管理解决方案</div>
                <ul class="content_ul">
                    <li class="wow animate__animated animate__fadeInRightBig" v-for="(item,index) in one8List" :key="index">
                        <div class="name">{{item.name}}</div>
                        <div class="explain">{{item.explain}}</div>
                    </li>
                    <li>
                        <div class="item_bottom">
                            <div class="ontrial"><img src="../../../../public/images/free.png" alt=""> 免费试用</div>
                            <div class="consult"><img class="be" src="../../../../public/images/consult.png" alt=""><img class="be_wh" src="../../../../public/images/consult_wh.png" alt=""> 详情咨询</div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="one9">
        <div class="enterprise_content one9_content">
            <div class="left">
                <div class="title">加工管理解决方案</div>
                <ul class="content_ul">
                    <li class="wow animate__animated animate__fadeInLeftBig" v-for="(item,index) in one9List" :key="index">
                        <div class="name">{{item.name}}</div>
                        <div class="explain">{{item.explain}}</div>
                    </li>
                    <li>
                        <div class="item_bottom">
                            <div class="ontrial"><img src="../../../../public/images/free.png" alt=""> 免费试用</div>
                            <div class="consult"><img class="be" src="../../../../public/images/consult.png" alt=""><img class="be_wh" src="../../../../public/images/consult_wh.png" alt=""> 详情咨询</div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="right">
                <machin />
            </div>
        </div>
    </div>
    <div class="one10">
        <div class="enterprise_content one10_content">
            <div class="left">
                <move />
            </div>
            <div class="right">
                <div class="title">移动办公解决方案</div>
                <ul class="content_ul">
                    <li class="wow animate__animated animate__fadeInRightBig" v-for="(item,index) in one10List" :key="index">
                        <div class="name">{{item.name}}</div>
                        <div class="explain">{{item.explain}}</div>
                    </li>
                    <li>
                        <div class="item_bottom">
                            <div class="ontrial"><img src="../../../../public/images/free.png" alt=""> 免费试用</div>
                            <div class="consult"><img class="be" src="../../../../public/images/consult.png" alt=""><img class="be_wh" src="../../../../public/images/consult_wh.png" alt=""> 详情咨询</div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="one11">
        <div class="enterprise_content one11_content">
            <div class="left">
                <div class="title">同行调货协同解决方案</div>
                <ul class="content_ul">
                    <li class="wow animate__animated animate__fadeInLeftBig" v-for="(item,index) in one11List" :key="index">
                        <div class="name">{{item.name}}</div>
                        <div class="explain">{{item.explain}}</div>
                    </li>
                    <li>
                        <div class="item_bottom">
                            <div class="ontrial"><img src="../../../../public/images/free.png" alt=""> 免费试用</div>
                            <div class="consult"><img class="be" src="../../../../public/images/consult.png" alt=""><img class="be_wh" src="../../../../public/images/consult_wh.png" alt=""> 详情咨询</div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="right">
                <peers />
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import painPoint from './components/painPoint'
import solutions from './components/solutions'
import inWarehous from './components/inWarehous'
import stock from './components/stock'
import sale from './components/sale'
import finance from './components/finance'
import machin from './components/machin'
import move from './components/move'
import peers from './components/peers'
import {WOW} from 'wowjs'
export default {
    name: '',
    components:{
        painPoint,
        solutions,
        inWarehous,
        stock,
        sale,
        finance,
        machin,
        move,
        peers
    },
    props: {
        
    },
    data(){
        return{
            one4List:[
                {
                    name:'客户管理系统',
                    explain:'CRM系统每天自动帮助销售梳理所有客户的维护情况。 自动根据客户未联系天数和未成交天数进行分类，提醒销售及时维护跟进。',
                },
                {
                    name:'回访记录',
                    explain:'记录回访日志，设置待办提醒，让用户管理客户井井有条。',
                },
                {
                    name:'客户公共池',
                    explain:'通过天数设置，对N天未联系或N天未成交的用户自动流转到公司公共池，并进行重新分配、开发 维护、合理利用客户资源，提高客户转化率。',
                },
                {
                    name:'转化率分析',
                    explain:'老板通过转化率图表分析，可以直观的看出公司整体的客户维护情况、成交情况，以及每个人的 工作效率和成果；通过图表分析出问题，并解决问题。用数据管理经营企业。',
                },
                {
                    name:'多终端操作',
                    explain:'支持PC+移动操作，销售和管理人员随时随地地轻松办公。',
                }
            ],
            one5List:[
                {
                    name:'待入库',
                    explain:'将所有待入库货物智能汇总，系统自动 识别货物是有货柜还是散货。'
                },
                {
                    name:'入库方式',
                    explain:'手机端操作，现场核对货物勾选直接入库 扫码入库'
                }
            ],
            one6List:[
                {
                    name:'多终端查询',
                    explain:'支持PC端、移动端库存查询，不论是办公室办公、外出出差，还是仓库现场都 可随时随地查询库存货物信息。'
                },
                {
                    name:'库存便携管理',
                    explain:'库存货物检尺、货物标签打印、批量修改货物信息'
                },
                {
                    name:'库存管控',
                    explain:'对在途资源、现货库存，根据资源状态、用户权限等实现分权、分仓管理；实现 跨区域销售联动、统一库存进出管理、全方位库存管控。'
                },
                
            ],
            one7List:[
                {
                    name:'快速建单',
                    explain:'自动关联销售人，多种方式添加客户，默认销售、收汇、发货日期，操作快速方便！'
                },
                {
                    name:'自动锁货',
                    explain:'智能添加商品，可筛选，可扫描，锁定后货物自动归属锁货人，减少企业内部恶性 竞争。'
                },
                {
                    name:'自动解锁',
                    explain:'设置系统自动解锁时间，超过设置时间自动释放库存，让资源更合理的分配与销售。'
                },
                {
                    name:'销售审核',
                    explain:'对货物销售全盘把控，每一件货的码单立方、销售立方、成本单价、销售单价及每 单的毛利率对比审核，让销售审核更轻松。'
                },
                {
                    name:'销售统计',
                    explain:'自动统计个人、客户及公司的销售方数、销售金额、销售利润，做到权限区分，BOSS 可以看到全部销售汇总，销售只能看到自己的销售方数和销售金额。'
                }
            ],
            one8List:[
                {
                    name:'强大的财务管理系统',
                    explain:'应收管理、费用管理、账户管理模块让应收应付款更容易管理。包含 其他收款、其他付款、内部资金转账、客户对账单、利润报表、费用 报表，让财务轻松玩转。',
                },
                {
                    name:'PC端+移动端',
                    explain:'支持PC端和移动端同时办公',
                },
                
            ],
            one9List:[
                {
                    name:'完善的加工管理',
                    explain:'加工类型分为：原木到干板、原木到湿板和湿板到干板',
                },
                {
                    name:'费用和成本自动核算',
                    explain:'加工费用结算单自动生成（系统可以自动计算出费用平摊单价）',
                },
                {
                    name:'',
                    explain:'成品成本单价自动核算（可抵扣发票金额、三角料金额自动核算出成本单价）',
                }
            ],
            one10List:[
                {
                    name:'工作流程规范化',
                    explain:'实现对流程化工作的自动化管理，规范员工各项工作，员工可快速在移动端发起流程，每个环节有据可循，办公信息自动留存。',
                },
                {
                    name:'事务处理高效化',
                    explain:'随时随地线上办公，审批信息即时通知，减少线下沟通时间，降低出错率。',
                },
                {
                    name:'企业办公无纸化',
                    explain:'PC端+移动端线上同步操作，整合时间碎片为企业创造最大化利润，重要业务审批不再被线下单据限制而延误，提高BOOS全局把控力。',
                },
                {
                    name:'数据分析可视化',
                    explain:'各项数据系统智能汇总成各个报表、图表等，辅助企业了解运营状态、找到发展症结以及帮助决策等。',
                }
            ],
            one11List:[
                {
                    name:'同行快速调货',
                    explain:'直接线上协同调货，双方采购单/销售单系统自动生成，无缝对接ERP系统，自动关联应收、应付。',
                },
                {
                    name:'一键分享',
                    explain:'通过云链管理一键自定义分享，公司难卖或滞压的库存，借助谱木云链跨区域分享，提高资金运作效率。',
                },
            ],
        }
    },
    mounted(){
        this.$nextTick(() => {
            let wow = new WOW({
                boxClass: "wow",    //需要执行动画的元素的 class
                animateClass: "animated", // animation.css 动画的 class
                offset: 0, // 距离可视区域多少开始执行动画
                mobile: false, // 是否在移动设备上执行动画
                live: false // 异步加载的内容是否有效
            })
            wow.init()
        })
    },
    methods:{
        
    }
}
</script>

<style scoped  lang="scss">
    .financeChain{
        overflow: hidden;
    }
    .one1{
        width: 100%;height: 100%;
        position: relative;
        .icon{
            height: 50rem;width: 100%;
        }
        .one1_content{
            width: 120rem;height: 65%;
            padding: 2rem 0;
            position: absolute;left: 50%;bottom: 0;transform: translateX(-50%); z-index: 2;
            border-top-left-radius: 0.6rem;
            border-top-right-radius: 0.6rem;
            color: #fff;
            .title_name{
                font-size: 4rem;text-align: center;
            }
            .title_name_one{text-indent: 10rem;font-weight: 500;}
            .title_name_two{text-indent: 10rem;font-size: 2.5rem;margin-top: 2rem;}
        }
    }
    .enterprise_content{width: 120rem;margin: 0 auto;}
    .content_ul{
        flex: 1;
        padding: 2rem 5rem;
        >li{
            margin-top: 1.3rem;
            .name{font-size: 1.6rem; font-weight: 600;}
            .explain{font-size: 1.4rem;color: #5D5D5D;margin-top: 0.5rem;}
        }
    }
    .one1_pain_point{
        height: 62rem;
        width: 120rem;
        margin-top: -21rem;
        position: relative;
        z-index: 6;
        background: #fff;
        box-shadow: 0 0 0.8rem rgba(0, 0, 0, 0.2);
        border-radius: 0.6rem;
    }
    .one2{
        width: 100%;height: 100%;
        position: relative;
    }
    .one3{
        margin-top: 1.5rem;
        .one3_content{
            background: #F5F6FA;
            display: flex;
            .left{
                flex: 1;
                padding: 2rem 5rem;
                .solutions{
                    >li{
                        margin-top: 1.5rem;
                        font-size: 1.4rem;
                    }
                }
            }
            .right{
                flex-basis: 40rem;
                text-align: right;
                padding: 2rem 2rem 0 0;
                .title{
                    font-size: 2.2rem;
                    font-weight: 600;
                    margin-bottom: 2rem;
                    text-align: center;
                }
            }
        }
    }
    .one4{
        margin-top: 2.5rem;
        .one4_content{
            .title{
                font-size: 2.2rem;
                font-weight: 600;
                padding-left: 2rem;
                margin-bottom: 2rem;
            }
            .solutions_content{
                padding-left: 2rem;
            }
            .solutions_bottom_content{
                display: flex;
                .right{
                    flex-basis: 40rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
    }
    
    .one5{
        margin-top: 3rem;
        .one5_content{
            background: #F5F6FA;
            display: flex;
            height: 62rem;
            .title{
                font-size: 2.2rem;
                font-weight: 600;
                padding: 6rem 5rem;
            }
            .left{
                flex-basis: 40rem;;
            }
            .right{
                flex: 1;
                padding: 2rem;
            }
        }
    }
    .one6{
        margin-top: 3rem;
        .one6_content{
            display: flex;
            height: 62rem;
            .left{
                flex: 1;
            }
            .right{
                flex-basis: 55rem;
                .title{
                    font-size: 2.2rem;
                    font-weight: 600;
                    padding: 2rem 5rem;
                }
            }
        }
    }
    .one7{
        .one7_content{
            background: #F5F6FA;
            display: flex;
            height: 60rem;
            .title{
                font-size: 2.2rem;
                font-weight: 600;
                padding: 3rem 5rem 2rem 5rem;
            }
            .left{
                flex-basis: 50rem;;
            }
            .right{
                flex: 1;
                padding: 2rem;
            }
        }
    }
    .one8{
        margin-top: 3rem;
        .one8_content{
            display: flex;
            height: 62rem;
            .left{
                flex: 1;
            }
            .right{
                flex-basis: 55rem;
                .title{
                    font-size: 2.2rem;
                    font-weight: 600;
                    padding: 2rem 5rem;
                }
            }
        }
    }
    .one9{
        .one9_content{
            background: #F5F6FA;
            display: flex;
            height: 60rem;
            .title{
                font-size: 2.2rem;
                font-weight: 600;
                padding: 3rem 5rem 2rem 5rem;
            }
            .left{
                flex-basis: 50rem;;
            }
            .right{
                flex: 1;
                padding: 2rem;
            }
        }
    }
    .one10{
        margin-top: 3rem;
        .one10_content{
            display: flex;
            height: 62rem;
            .left{
                flex: 1;
            }
            .right{
                flex-basis: 55rem;
                .title{
                    font-size: 2.2rem;
                    font-weight: 600;
                    padding: 2rem 5rem;
                }
            }
        }
    }
    .one11{
        .one11_content{
            background: #F5F6FA;
            display: flex;
            height: 60rem;
            margin-bottom: 6rem;
            .title{
                font-size: 2.2rem;
                font-weight: 600;
                padding: 3rem 5rem 2rem 5rem;
            }
            .left{
                flex-basis: 50rem;;
            }
            .right{
                flex: 1;
                padding: 2rem;
            }
        }
    }
</style>
